import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import BgImg1 from "../../../images/case-studies/mdrouz/solution_back.png";
import Img1 from "../../../images/case-studies/mdrouz/solution_mob.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Solutioncase = () => {
  return (
    <div className="solution_case" style={{ backgroundImage: `url(${BgImg1})`}}>
          <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto offset-xl-8 offset-lg-8">
                        <h2>The <span>Solution</span></h2>
                        <p>TekRevol addressed the identified challenges by conducting in-depth market research, ensuring a thorough understanding of user preferences and shortcomings in existing solutions. The development team focused on creating a robust multi-vendor e-commerce app with features such as easy navigation, secure payment integration with Upayment, personalized recommendations, and a visually appealing interface. The solution aimed to elevate the online shopping experience for users in the GCC region.</p>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="sol_mob d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none">
                      <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="TekRevol" className="img-fluid"
                                />
                      </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Solutioncase